import { getUnique } from "@/utils/number/unique";
import { formatDate } from "@/utils/date/format";

function formatBalance(balance) {
    balance = +balance;
    balance = Math.round(balance);
    return balance;
}

export function Function(data) {
    this.isShowRow = true;
    this.unique = getUnique();

    this.id = {
        value: data.id
    };

    this.status = {
        value: data.status.code,
        title: data.status.title,
        custom: true,
    };

    this.name = {
        value: data.name
    };

    this.executive = {
        typePosts: data.executives.typePosts,
        posts: data.executives.posts,
        workers: data.executives.workers.map(worker => ({
            user: {
                id: null,
                name: null
            },
            worker: {
                id: worker.id,
                name: worker.name
            }
        })),
        custom: true,
    };

    this.filials = {
        value: data.filials && data.filials.length ? data.filials.map(filial => (filial.name)).join(', <br>') : "Все",
        custom: true,
    };

    this.responsible = {
        value: data.responsible.map(worker => ({
            user: {
                id: null,
                name: null
            },
            worker: {
                id: worker.id,
                name: worker.name
            }
        })),
        custom: true,
    };

    this.labor_costs = {
        value: data.labor_costs,
        repeat_interval: data.repeat_interval,
        repeat_type: data.repeat_type,
        custom: true,
    };
    
    this.tools = {
        value: data.tools && data.tools.length ? data.tools.map(tool => (tool.name)).join(', ') : "-"
    };

    this.indicators = {
        value: data.indicators.length,
        custom: true,
    }

    this.comments = {
        value: data.comment
    }
}
